<app-page-header [data]="header()" [fullPath]="fullPath()"></app-page-header>
<div class="hero-img-wrapper">
    <img priority class="mobile" [ngSrc]="heroImageSrc()" [width]="580" [height]="580"
        [loaderParams]="{width: 580, height: 580, fillWithFaceFocus: true}" sizes="100vw" [alt]="heroImageTitle()"
        [title]="heroImageTitle()">
    <img priority class="desktop" [ngSrc]="heroImageSrc()" [width]="1000" [height]="500"
        [loaderParams]="{width: 1000, height: 500, fillWithFaceFocus: true}" sizes="(max-width: 1300px) 90em, 100vw"
        [alt]="heroImageTitle()" [title]="heroImageTitle()">
</div>
<div class="hero-text-container">
    <h1>{{ heroHeadline() }}</h1>
    <div class="line"></div>
    <p>{{ heroSubline() }}</p>
</div>
<div class="module">
    @if (claimIsSlider()) {
        <app-text-slider [sliderProperties]="sliderPropertiesFromClaim()"></app-text-slider>
    }
    @else {
        <app-base-text [text]="claim()" [align]="'center'" [big]="true" [bold]="true" [gotham]="true" [htmlTag]="'h2'" />
    }
    <app-base-text [text]="aboutUs()" [align]="'center'" />
</div>
@for(element of contentElements(); track $index) {
<ng-container *ngComponentOutlet="element?.component; inputs: element?.inputs" />
}
<app-page-footer [data]="footer()"></app-page-footer>